/**
 * Customer form validation
 *
 * Form should contain fields where input attribute name starts with "contact"
 * name="contact[email]"
 * The error message wrapper should have data-error="email" and data-text containing the error message
 * And always add the aria-live polite to the error message wrapper

 * For example:
 *

<div class="field--wrapper">
  <input
    id="NewsletterForm--{{ section.id }}"
    type="email"
    name="contact[email]"
    class="focus-offset"
    aria-required="true"
    autocorrect="off"
    autocapitalize="off"
    autocomplete="email"
    placeholder="{{ 'newsletter.label' | t }}"
    required
  >
  <button
    type="submit"
    class="button circle--md"
    name="commit"
    id="Subscribe"
    aria-label="{{ 'newsletter.button_label' | t }}"
  >
    {% render 'icon', icontype: 'icon-arrow' %}
  </button>
</div>
<div
  class="error-message"
  aria-live="polite"
  data-error="email"
  data-text="{{ 'newsletter.email_error' | t }}"
></div>
*/

class CustomerFormValidation extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.fields = ['name','email', 'message-required']; //extend this array to include other fields, like first_name, last_name, etc.

    this.submitButton.addEventListener('click', event => {
      event.stopPropagation();

      this.fields.forEach(field => {
        const input = this.form.querySelector(`[name="contact[${field}]"]`);
        if (!input) return;

        if (field == 'email') {
          if (!this.validateEmail(input.value)) {
            event.preventDefault();
            this.showError('email');
          }
        }
        else {
          // check if field has been filled
          if (!this.validateField(input.value)) {
            event.preventDefault();
            this.showError(field);
          }
        }
      });

      // If the form is not valid, we've already prevented the default action
      // If it is valid, we let the form submit naturally
    });
  }

  validateField(value) {
    if (value === '' || value === null || value === undefined) {
      return false;
    }
    else {
      return true;
    }
  }

  validateEmail(value) {
    if (!value) return false;

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  }

  showError(fieldName) {
    const errorElement = this.querySelector(`[data-error="${fieldName}"]`);
    if (!errorElement) return;

    const message = errorElement.dataset.text;
    errorElement.textContent = message;
    errorElement.style.display = 'block';
  }
}

if (!customElements.get('customer-form-validation')) {
  customElements.define('customer-form-validation', CustomerFormValidation);
}
